import { TipoRegistroTurno } from "@fixeduy/restaurantestypes";

export interface TipoRegistroTurnoOption {
  value: TipoRegistroTurno;
  label: string;
  /** Clases Tailwind para badge/chip (bg, text, border) */
  badgeClasses: string;
}

export const TIPOS_REGISTRO_TURNO: TipoRegistroTurnoOption[] = [
  {
    value: "ingreso",
    label: "Ingreso",
    badgeClasses:
      "bg-[#BCE2C580] text-[#74AA81] border-success/30 dark:bg-success/30 dark:border-success/50"
  },
  {
    value: "descansoInicio",
    label: "Descanso",
    badgeClasses:
      "bg-[#45454533] text-#454545 border-amber-200 dark:bg-amber-900/40 dark:text-amber-200 dark:border-amber-700"
  },
  {
    value: "descansoFin",
    label: "Volver",
    badgeClasses:
      "bg-[#E09C2D33] text-[#E09C2D] border-info/30 dark:bg-info/30 dark:border-info/50"
  },
  {
    value: "salida",
    label: "Salida",
    badgeClasses:
      "bg-[#B3617F59] text-[#751B4E] border-slate-200 dark:bg-slate-700 dark:text-slate-200 dark:border-slate-600"
  }
];

export function getTipoRegistroTurnoLabel(value: string): string {
  return TIPOS_REGISTRO_TURNO.find(e => e.value === value)?.label ?? value;
}
